import ApplicationController from '../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    'reason',
    'form'
  ]

  // ==== Controllers

  // ==== Actions

  toggle({ currentTarget: { checked } }) {
    this.reasonTarget.classList.toggle('u-hide', !checked)
    this.formTarget.classList.toggle('u-hide', checked)
  }

  // ==== Getters

  // ==== Private

  // ==== Channels

}
